import { useQuery } from '@tanstack/react-query';
import Card from '../../components/common/Card';
import AnnouncementCard from '../../components/announcements/AnnouncementCard';
import { getAnnouncements } from '../../services/announcementService';
import { MdCampaign, MdWarning } from 'react-icons/md';

function Notices() {
  document.title = 'Notices — TrainAxis';
  const { data, isPending } = useQuery({
    queryKey: ['announcements-student'],
    queryFn:  () => getAnnouncements({ audience: 'students' }).then(r => r.data),
    refetchInterval: 60000,
  });

  const announcements = data?.announcements || [];
  const urgent = announcements.filter(a => a.type === 'urgent');

  return (
    <div className="mx-auto w-full max-w-4xl">
      {/* Urgent banner — adaptive red chip tokens (consistent in light + dark) */}
      {urgent.length > 0 && (
        <div className="bg-red-100 border border-red-200 rounded-2xl p-4 mb-4 flex items-start gap-3">
          <MdWarning className="text-2xl text-red-500 flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-red-700 text-sm">Urgent Notice{urgent.length > 1 ? 's' : ''}</p>
            {urgent.map(a => (
              <p key={a._id} className="text-xs text-red-700/80 mt-0.5">{a.title}</p>
            ))}
          </div>
        </div>
      )}

      <p className="text-muted text-sm mb-6">
        {announcements.length} notice{announcements.length !== 1 ? 's' : ''}
      </p>

      {isPending ? (
        <div className="flex flex-col gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-32 bg-gray-100 animate-pulse rounded-lg" />
          ))}
        </div>
      ) : !announcements.length ? (
        <Card>
          <div className="flex flex-col items-center py-14 text-center">
            <MdCampaign className="text-5xl text-subtle mb-3" />
            <p className="text-muted text-sm">No announcements yet</p>
            <p className="text-xs text-subtle mt-1">Check back later for club news and updates</p>
          </div>
        </Card>
      ) : (
        <div className="flex flex-col gap-3">
          {announcements.map(a => (
            <AnnouncementCard key={a._id} announcement={a} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Notices;
